import { encodeDataURL } from "@withorbit/store-shared";
import { Dexie as DexieDB } from "dexie";
/*
This is a simplistic implementation of AttachmentStore for web clients. It stores attachment data in IndexedDB. The downside of this approach is that attachments are displayed using base64 URLs, which are of course quite inefficient. It would be better to use a service worker and CacheStorage, but that would be dramatically more complex. This will do for now.
 */
export class AttachmentStoreWeb {
    _db;
    _table;
    constructor(name, indexedDB = window.indexedDB) {
        this._db = new DexieDB(name, { indexedDB });
        this._db.version(1).stores({
            attachments: "&id",
        });
        this._table = this._db.table("attachments");
    }
    async storeAttachment(contents, id, type) {
        await this._table.put({
            id,
            data: contents,
            type,
        });
    }
    async getURLForStoredAttachment(id) {
        const row = await this._table.get(id);
        if (row) {
            return encodeDataURL(row.data.buffer, row.type);
        }
        else {
            return null;
        }
    }
    async getAttachment(id) {
        const row = await this._table.get(id);
        if (row) {
            return { contents: row.data, type: row.type };
        }
        else {
            throw new Error(`Missing attachment ${id}`);
        }
    }
}
//# sourceMappingURL=attachmentStoreWeb.js.map